import { render } from "./RSVPForm.vue?vue&type=template&id=938f203a&scoped=true"
import script from "./RSVPForm.vue?vue&type=script&lang=js"
export * from "./RSVPForm.vue?vue&type=script&lang=js"

import "./RSVPForm.vue?vue&type=style&index=0&id=938f203a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-938f203a"]])

export default __exports__